import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import { Paper } from "@material-ui/core";

import PageBase from "../../components/PageBase";
import BirthdaySettings from "../../components/BirthdaySettings";

const useStyles = makeStyles((theme) => ({
  mainPaper: {
    flex: 1,
    padding: 0,
    overflowY: "scroll",
    ...theme.scrollbarStyles,
  },
}));

const BirthdaySettingsPage = () => {
  const classes = useStyles();

  return (
    <PageBase
      className="birthday-settings-page app-page-root"
      title="🎂 Configurações de Aniversário"
      containerProps={{ className: classes.mainPaper }}
    >
      <Paper variant="outlined">
        <BirthdaySettings />
      </Paper>
    </PageBase>
  );
};

export default BirthdaySettingsPage;
